import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { regionPost } from "../../store/region/actions";
export var useRegionPost = function (trigger, bodyRequest) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePostRegion: (_a = state.Region.responsePostRegion) === null || _a === void 0 ? void 0 : _a.data,
            errorPostRegion: state.Region.errorPostRegion,
            loadingPostRegion: state.Region.loadingPostRegion,
        });
    }), responsePostRegion = _a.responsePostRegion, errorPostRegion = _a.errorPostRegion, loadingPostRegion = _a.loadingPostRegion;
    useEffect(function () {
        if (trigger) {
            dispatch(regionPost(bodyRequest));
        }
    }, [bodyRequest, trigger]);
    return {
        responsePostRegion: responsePostRegion,
        errorPostRegion: errorPostRegion,
        loadingPostRegion: loadingPostRegion
    };
};
